import { AfterContentChecked, AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { isNull } from 'util';

// tslint:disable-next-line: class-name
interface anchorItem {
  htmlId: string;
  name: string;
  children: Array<any>;
  childClassName?: string;
  eventList?: Array<any>;
  isFold?: boolean;
  scrollTop?: number;
}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-anchor',
  templateUrl: './icc-anchor.component.html',
  styleUrls: ['./icc-anchor.component.less'],
})
export class IccAnchorComponent implements OnInit, AfterViewInit, OnDestroy, AfterContentChecked {
  @ViewChild('anchorarrow', { static: false }) anchorArrow;
  // 滚动条所在元素的id，可配置
  @Input() scrollId = 'alain-default-content-id';
  // 平台面包屑的高度
  @Input() breadCrumbHeight: any;
  // pageInner的高度
  @Input() pageInnerHeight: any;
  // 锚点父级dom的id
  @Input() fatherId: string;
  // 数据源
  @Input() list: Array<anchorItem> = [];
  @Input() isChangeClass = true;
  // 是否显示指向
  @Input() showRefer = true;
  // 只读 - true时，不可使用插槽和事件，只提供快捷导航和折叠的功能 -- false时，可以添加事件和插槽 -- 默认为false
  @Input() readonly: boolean;
  @Input() isDetail: boolean;
  liHeight = 0;
  hasList = false;
  // 滚动元素
  scrollDom = null;
  // 组件相对滚动区元素的初始偏移量
  initOffsetTop = 0;
  // 箭头相对组件的初始偏移量
  initArrowTop = 0;
  // 控制组件的布局
  hasFixedClass = false;

  oldTime: any = new Date();
  // 滚动事件
  scrollFn = evt => {
    if (!this.initOffsetTop) {
      this.initOffsetTop = this.getDomOffsetTop(this.el.nativeElement);
    }
    if (this.isChangeClass) {
      if (evt.target.scrollTop > this.initOffsetTop) {
        this.hasFixedClass = true;
      } else {
        this.hasFixedClass = false;
      }
    }

    this.ngAfterContentChecked();
    const timeout = setTimeout(() => {
      const arrowElement = this.anchorArrow.nativeElement;
      if (!this.liHeight) {
        this.liHeight = this.el.nativeElement.getElementsByTagName('li')[0].clientHeight;
      }
      if (!this.initArrowTop) {
        this.initArrowTop = arrowElement.offsetTop;
      }
      for (let i = 0; i < this.list.length; i++) {
        let isBreak = false;
        if (Math.abs(evt.target.scrollTop - this.list[i].scrollTop) < 15) {
          arrowElement.style.top = this.initArrowTop + this.liHeight * Math.max(this.getArrowIndex(i, null), 0) + 'px';
          isBreak = true;
        } else if (this.list[i].children instanceof Array) {
          for (let k = 0; k < this.list[i].children.length; k++) {
            if (evt.target.scrollTop <= this.list[i].children[k].scrollTop) {
              arrowElement.style.top = this.initArrowTop + this.liHeight * Math.max(this.getArrowIndex(i, k), 0) + 'px';
              isBreak = true;
              break;
            }
          }
        }
        if (isBreak) {
          break;
        }
      }
      // if (!this.showRefer) {
      //   this.showRefer = true;
      // }
      clearTimeout(timeout);
    }, 200);
  };
  constructor(private el: ElementRef) {}
  ngOnInit(): void {}
  ngAfterViewInit(): void {
    console.log('Anchor.list :>> ', this.list);
    if (typeof this.breadCrumbHeight === 'undefined') {
      const breadCrumb = document.getElementsByClassName('bread-crumb');
      if (breadCrumb && breadCrumb[0]) {
        this.breadCrumbHeight = breadCrumb[0].clientHeight;
      } else {
        this.breadCrumbHeight = 0;
      }
    }
    if (typeof this.pageInnerHeight === 'undefined') {
      const pageInnerDom = document.getElementsByClassName('icc-page-inner-header');
      if (pageInnerDom && pageInnerDom[0]) {
        this.pageInnerHeight = pageInnerDom[0].clientHeight;
      } else {
        this.pageInnerHeight = 0;
      }
    }
    this.scrollDom = this.getDomById(this.scrollId);
    this.getDomById(this.scrollId).addEventListener('scroll', this.scrollFn);
  }
  ngOnDestroy(): void {
    this.scrollDom.removeEventListener('scroll', this.scrollFn);
    // console.log('anchor destroy');
  }
  ngAfterContentChecked() {
    if (!this.hasList && this.list && this.list.length) {
      this.list.forEach(item => {
        item.scrollTop = this.getDomOffsetTop(this.getDomById(item.htmlId));
        if (item.children instanceof Array) {
          item.children.forEach(child => {
            child.scrollTop = this.getDomOffsetTop(this.getDomById(child.htmlId));
          });
        }
      });
    }
  }
  /* 根据一二级的下标获取需要计算高度时用到的数量 */
  getArrowIndex(index, childIndex) {
    let arrowIndex = 0;
    for (let i = 0; i < this.list.length; i++) {
      if (index !== i) {
        arrowIndex += this.list[i].children && !this.list[i].isFold && this.list[i].children.length ? 1 + this.list[i].children.length : 1;
      } else {
        if (!this.list[i].isFold) {
          arrowIndex += childIndex === null ? 0 : childIndex + 1;
        }
        break;
      }
    }
    return arrowIndex;
  }
  /*点击事件*/
  quickLink(evt, sign, index, childIndex) {
    console.log('evt :>> ', evt);
    console.log('sign :>> ', sign);
    console.log('index :>> ', index);
    console.log('childIndex :>> ', childIndex);
    const arrowElement = this.anchorArrow.nativeElement;
    const currentLi = this.getParentDomByTag(evt.target, 'LI');
    if (!this.initArrowTop) {
      this.initArrowTop = arrowElement.offsetTop;
    }
    // 设置箭头指向: 点击定位方式一, 也可使用事件，见方式二
    arrowElement.style.top = this.initArrowTop + currentLi.clientHeight * this.getArrowIndex(index, childIndex) + 'px';

    if (!this.initOffsetTop) {
      this.initOffsetTop = this.getDomOffsetTop(this.el.nativeElement);
    }
    // 设置滚动条位置
    // this.scrollDom.scrollTop = this.getPositionById(sign);
    this.scrollDom.scrollTop = isNull(childIndex) ? this.getPositionById(sign) : this.getPositionByClassName(sign, childIndex);

    // document.querySelectorAll(sign)[index].scrollIntoView();
    // 设置fixed样式
    // tslint:disable-next-line: prefer-conditional-expression

    if (this.isChangeClass) {
      if (this.scrollDom.scrollHeight - this.initOffsetTop >= this.scrollDom.clientHeight) {
        this.hasFixedClass = true;
      } else {
        this.hasFixedClass = false;
      }
    }

    // this.showRefer = true;
  }
  /* 点击定位方式二：点击锚点名称时候的事件 */
  location(evt) {
    return false;
  }

  getPositionById(id) {
    // let tempArr = this.list.filter(item => id === item.htmlId);
    // if (!tempArr.length) {
    //   // tslint:disable-next-line: prefer-for-of
    //   for (let i = 0; i < this.list.length; i++) {
    //     tempArr = this.list[i].children.filter(child => id === child.htmlId);
    //     if (tempArr.length) {
    //       break;
    //     }
    //   }
    // }
    // return tempArr[0].scrollTop;
    const _ele = document.getElementById(id);
    if (_ele) return this.getDomOffsetTop(_ele, true);
  }
  /** 通过类名获取位置 */
  getPositionByClassName(className, index?: number) {
    const _ele = document.querySelectorAll(className)[index];
    if (_ele) return this.getDomOffsetTop(_ele);
  }

  /*获取该元素在滚动区域的位置，需要注意父元素dom中的position布局*/
  getDomOffsetTop(dom, isFather?: boolean) {
    let top = this.breadCrumbHeight + this.pageInnerHeight;
    const getOffsetTop = el => {
      if (el && el.id !== this.fatherId) {
        top += el.offsetTop;
        getOffsetTop(el.parentElement);
      }
    };
    getOffsetTop(dom);
    // 如果是详情部分，由于HTML布局与不同编辑部分不同，所以需要对top值做处理
    const eleAppBiz = document.getElementsByTagName('form')[0];
    if (this.isDetail) {
      top = top + eleAppBiz.offsetHeight - 22;
    }
    return top;
  }
  /*从dom树上的具体元素往上查找最近的符合元素name的节点*/
  getParentDomByTag(dom, tagName) {
    let target;
    const iteratorFn = el => {
      if (el.tagName === tagName) {
        target = el;
      } else {
        iteratorFn(el.parentElement);
      }
    };
    iteratorFn(dom);
    return target;
  }
  /*通过id获取元素*/
  getDomById(id) {
    return document.getElementById(id);
  }
  /* 展开/收起 */
  toggle(item: anchorItem) {
    item.isFold = !item.isFold;
    // this.showRefer = false;
  }

  handleClick(target) {
    // 限制频率
    const currentTime: any = new Date();
    if (currentTime - this.oldTime < 400) return;

    this.oldTime = currentTime;
    target.click(target.params);
  }
}
